import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RecaptchaLoaderService } from '../../services/recaptcha.loader.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ppl-recaptcha',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './recaptcha.component.html',
    styleUrl: './recaptcha.component.css'
})
export class RecaptchaComponent implements OnInit {
    @Output() captchaResolved = new EventEmitter<any>();

    captchaResponse: string | null = null;
    verificationStatus: string | null = null;
    recaptchaSiteKey: string = environment.googleRecaptchaKey;  // Use the site key from environment

    ngOnInit(): void {
        const interval = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.enterprise) {
                window.grecaptcha.enterprise.render('recaptcha-container', {
                    sitekey: this.recaptchaSiteKey,
                    callback: (response: string) => this.onCaptchaResolved(response),
                    'expired-callback': () => this.onCaptchaExpired(),
                });
                clearInterval(interval);
            }
        }, 100);
    }

    onCaptchaResolved(response: string): void {
        console.log('CAPTCHA resolved successfully:', response);
        this.captchaResolved.emit(response);
    }

    onCaptchaExpired(): void {
        console.log('CAPTCHA expired. Please retry.');
    }
}